var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.8 140.2V479c0 18.2-14.8 33-33 33H102.9c-18.2 0-33-14.8-33-33V33c0-18.2 14.8-33 33-33h197.6z",
    fill: "#f5b912"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.6 233.5H189.1c-12.5 0-22.6 10.1-22.6 22.6v134.5c0 12.5 10.1 22.6 22.6 22.6h134.5c12.5 0 22.6-10.1 22.6-22.6V256c0-12.4-10.1-22.5-22.6-22.5zm-.7 139.5h-133v-90.5h133z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 134.4l121.1 98.1v-92.2L372 100.5z",
    opacity: 0.19
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M441.4 140.2H334.2c-18.2 0-33-14.8-33-33V0z",
    fill: "#fadc87"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlides);
export default __webpack_public_path__ + "static/media/slides.e792a1c555a07b815eb16be0af68d750.svg";
export { ForwardRef as ReactComponent };